export const compose = (...fns: Function[]) => <T, >(initialArg: T) => fns.reduceRight((acc, fn) => fn(acc), initialArg);

export const pipe = (...fns: Function[]) => <T, >(initialArg: T) => fns.reduce((acc, fn) => fn(acc), initialArg);

export const trace = (label: string) => <T, >(value: T) => {
  console.log(`${ label }: ${ value }`);

  return value;
};

type curriedBinaryFn = <A, B>(a: A) => (b: B) => unknown;

export const flip = <A, B>(fn: curriedBinaryFn) => (a: A) => (b: B) => fn(b)(a);
